var map = {
	"./ad.png": "./src/assets/img/flags/ad.png",
	"./ae.png": "./src/assets/img/flags/ae.png",
	"./af.png": "./src/assets/img/flags/af.png",
	"./ag.png": "./src/assets/img/flags/ag.png",
	"./ai.png": "./src/assets/img/flags/ai.png",
	"./al.png": "./src/assets/img/flags/al.png",
	"./am.png": "./src/assets/img/flags/am.png",
	"./ao.png": "./src/assets/img/flags/ao.png",
	"./aq.png": "./src/assets/img/flags/aq.png",
	"./ar.png": "./src/assets/img/flags/ar.png",
	"./as.png": "./src/assets/img/flags/as.png",
	"./at.png": "./src/assets/img/flags/at.png",
	"./au.png": "./src/assets/img/flags/au.png",
	"./aw.png": "./src/assets/img/flags/aw.png",
	"./ax.png": "./src/assets/img/flags/ax.png",
	"./az.png": "./src/assets/img/flags/az.png",
	"./ba.png": "./src/assets/img/flags/ba.png",
	"./bb.png": "./src/assets/img/flags/bb.png",
	"./bd.png": "./src/assets/img/flags/bd.png",
	"./be.png": "./src/assets/img/flags/be.png",
	"./bf.png": "./src/assets/img/flags/bf.png",
	"./bg.png": "./src/assets/img/flags/bg.png",
	"./bh.png": "./src/assets/img/flags/bh.png",
	"./bi.png": "./src/assets/img/flags/bi.png",
	"./bj.png": "./src/assets/img/flags/bj.png",
	"./bl.png": "./src/assets/img/flags/bl.png",
	"./bm.png": "./src/assets/img/flags/bm.png",
	"./bn.png": "./src/assets/img/flags/bn.png",
	"./bo.png": "./src/assets/img/flags/bo.png",
	"./bq.png": "./src/assets/img/flags/bq.png",
	"./br.png": "./src/assets/img/flags/br.png",
	"./bs.png": "./src/assets/img/flags/bs.png",
	"./bt.png": "./src/assets/img/flags/bt.png",
	"./bv.png": "./src/assets/img/flags/bv.png",
	"./bw.png": "./src/assets/img/flags/bw.png",
	"./by.png": "./src/assets/img/flags/by.png",
	"./bz.png": "./src/assets/img/flags/bz.png",
	"./ca.png": "./src/assets/img/flags/ca.png",
	"./cc.png": "./src/assets/img/flags/cc.png",
	"./cd.png": "./src/assets/img/flags/cd.png",
	"./cf.png": "./src/assets/img/flags/cf.png",
	"./cg.png": "./src/assets/img/flags/cg.png",
	"./ch.png": "./src/assets/img/flags/ch.png",
	"./ci.png": "./src/assets/img/flags/ci.png",
	"./ck.png": "./src/assets/img/flags/ck.png",
	"./cl.png": "./src/assets/img/flags/cl.png",
	"./cm.png": "./src/assets/img/flags/cm.png",
	"./cn.png": "./src/assets/img/flags/cn.png",
	"./co.png": "./src/assets/img/flags/co.png",
	"./cr.png": "./src/assets/img/flags/cr.png",
	"./cu.png": "./src/assets/img/flags/cu.png",
	"./cv.png": "./src/assets/img/flags/cv.png",
	"./cw.png": "./src/assets/img/flags/cw.png",
	"./cx.png": "./src/assets/img/flags/cx.png",
	"./cy.png": "./src/assets/img/flags/cy.png",
	"./cz.png": "./src/assets/img/flags/cz.png",
	"./de.png": "./src/assets/img/flags/de.png",
	"./dj.png": "./src/assets/img/flags/dj.png",
	"./dk.png": "./src/assets/img/flags/dk.png",
	"./dm.png": "./src/assets/img/flags/dm.png",
	"./do.png": "./src/assets/img/flags/do.png",
	"./dz.png": "./src/assets/img/flags/dz.png",
	"./ec.png": "./src/assets/img/flags/ec.png",
	"./ee.png": "./src/assets/img/flags/ee.png",
	"./eg.png": "./src/assets/img/flags/eg.png",
	"./eh.png": "./src/assets/img/flags/eh.png",
	"./er.png": "./src/assets/img/flags/er.png",
	"./es.png": "./src/assets/img/flags/es.png",
	"./et.png": "./src/assets/img/flags/et.png",
	"./eu.png": "./src/assets/img/flags/eu.png",
	"./fi.png": "./src/assets/img/flags/fi.png",
	"./fj.png": "./src/assets/img/flags/fj.png",
	"./fk.png": "./src/assets/img/flags/fk.png",
	"./fm.png": "./src/assets/img/flags/fm.png",
	"./fo.png": "./src/assets/img/flags/fo.png",
	"./fr.png": "./src/assets/img/flags/fr.png",
	"./ga.png": "./src/assets/img/flags/ga.png",
	"./gb-eng.png": "./src/assets/img/flags/gb-eng.png",
	"./gb-nir.png": "./src/assets/img/flags/gb-nir.png",
	"./gb-sct.png": "./src/assets/img/flags/gb-sct.png",
	"./gb-wls.png": "./src/assets/img/flags/gb-wls.png",
	"./gb.png": "./src/assets/img/flags/gb.png",
	"./gd.png": "./src/assets/img/flags/gd.png",
	"./ge.png": "./src/assets/img/flags/ge.png",
	"./gf.png": "./src/assets/img/flags/gf.png",
	"./gg.png": "./src/assets/img/flags/gg.png",
	"./gh.png": "./src/assets/img/flags/gh.png",
	"./gi.png": "./src/assets/img/flags/gi.png",
	"./gl.png": "./src/assets/img/flags/gl.png",
	"./gm.png": "./src/assets/img/flags/gm.png",
	"./gn.png": "./src/assets/img/flags/gn.png",
	"./gp.png": "./src/assets/img/flags/gp.png",
	"./gq.png": "./src/assets/img/flags/gq.png",
	"./gr.png": "./src/assets/img/flags/gr.png",
	"./gs.png": "./src/assets/img/flags/gs.png",
	"./gt.png": "./src/assets/img/flags/gt.png",
	"./gu.png": "./src/assets/img/flags/gu.png",
	"./gw.png": "./src/assets/img/flags/gw.png",
	"./gy.png": "./src/assets/img/flags/gy.png",
	"./hk.png": "./src/assets/img/flags/hk.png",
	"./hm.png": "./src/assets/img/flags/hm.png",
	"./hn.png": "./src/assets/img/flags/hn.png",
	"./hr.png": "./src/assets/img/flags/hr.png",
	"./ht.png": "./src/assets/img/flags/ht.png",
	"./hu.png": "./src/assets/img/flags/hu.png",
	"./id.png": "./src/assets/img/flags/id.png",
	"./ie.png": "./src/assets/img/flags/ie.png",
	"./il.png": "./src/assets/img/flags/il.png",
	"./im.png": "./src/assets/img/flags/im.png",
	"./in.png": "./src/assets/img/flags/in.png",
	"./io.png": "./src/assets/img/flags/io.png",
	"./iq.png": "./src/assets/img/flags/iq.png",
	"./ir.png": "./src/assets/img/flags/ir.png",
	"./is.png": "./src/assets/img/flags/is.png",
	"./it.png": "./src/assets/img/flags/it.png",
	"./je.png": "./src/assets/img/flags/je.png",
	"./jm.png": "./src/assets/img/flags/jm.png",
	"./jo.png": "./src/assets/img/flags/jo.png",
	"./jp.png": "./src/assets/img/flags/jp.png",
	"./ke.png": "./src/assets/img/flags/ke.png",
	"./kg.png": "./src/assets/img/flags/kg.png",
	"./kh.png": "./src/assets/img/flags/kh.png",
	"./ki.png": "./src/assets/img/flags/ki.png",
	"./km.png": "./src/assets/img/flags/km.png",
	"./kn.png": "./src/assets/img/flags/kn.png",
	"./kp.png": "./src/assets/img/flags/kp.png",
	"./kr.png": "./src/assets/img/flags/kr.png",
	"./kw.png": "./src/assets/img/flags/kw.png",
	"./ky.png": "./src/assets/img/flags/ky.png",
	"./kz.png": "./src/assets/img/flags/kz.png",
	"./la.png": "./src/assets/img/flags/la.png",
	"./lb.png": "./src/assets/img/flags/lb.png",
	"./lc.png": "./src/assets/img/flags/lc.png",
	"./li.png": "./src/assets/img/flags/li.png",
	"./lk.png": "./src/assets/img/flags/lk.png",
	"./lr.png": "./src/assets/img/flags/lr.png",
	"./ls.png": "./src/assets/img/flags/ls.png",
	"./lt.png": "./src/assets/img/flags/lt.png",
	"./lu.png": "./src/assets/img/flags/lu.png",
	"./lv.png": "./src/assets/img/flags/lv.png",
	"./ly.png": "./src/assets/img/flags/ly.png",
	"./ma.png": "./src/assets/img/flags/ma.png",
	"./mc.png": "./src/assets/img/flags/mc.png",
	"./md.png": "./src/assets/img/flags/md.png",
	"./me.png": "./src/assets/img/flags/me.png",
	"./mf.png": "./src/assets/img/flags/mf.png",
	"./mg.png": "./src/assets/img/flags/mg.png",
	"./mh.png": "./src/assets/img/flags/mh.png",
	"./mk.png": "./src/assets/img/flags/mk.png",
	"./ml.png": "./src/assets/img/flags/ml.png",
	"./mm.png": "./src/assets/img/flags/mm.png",
	"./mn.png": "./src/assets/img/flags/mn.png",
	"./mo.png": "./src/assets/img/flags/mo.png",
	"./mp.png": "./src/assets/img/flags/mp.png",
	"./mq.png": "./src/assets/img/flags/mq.png",
	"./mr.png": "./src/assets/img/flags/mr.png",
	"./ms.png": "./src/assets/img/flags/ms.png",
	"./mt.png": "./src/assets/img/flags/mt.png",
	"./mu.png": "./src/assets/img/flags/mu.png",
	"./mv.png": "./src/assets/img/flags/mv.png",
	"./mw.png": "./src/assets/img/flags/mw.png",
	"./mx.png": "./src/assets/img/flags/mx.png",
	"./my.png": "./src/assets/img/flags/my.png",
	"./mz.png": "./src/assets/img/flags/mz.png",
	"./na.png": "./src/assets/img/flags/na.png",
	"./nc.png": "./src/assets/img/flags/nc.png",
	"./ne.png": "./src/assets/img/flags/ne.png",
	"./nf.png": "./src/assets/img/flags/nf.png",
	"./ng.png": "./src/assets/img/flags/ng.png",
	"./ni.png": "./src/assets/img/flags/ni.png",
	"./nl.png": "./src/assets/img/flags/nl.png",
	"./no.png": "./src/assets/img/flags/no.png",
	"./np.png": "./src/assets/img/flags/np.png",
	"./nr.png": "./src/assets/img/flags/nr.png",
	"./nu.png": "./src/assets/img/flags/nu.png",
	"./nz.png": "./src/assets/img/flags/nz.png",
	"./om.png": "./src/assets/img/flags/om.png",
	"./pa.png": "./src/assets/img/flags/pa.png",
	"./pe.png": "./src/assets/img/flags/pe.png",
	"./pf.png": "./src/assets/img/flags/pf.png",
	"./pg.png": "./src/assets/img/flags/pg.png",
	"./ph.png": "./src/assets/img/flags/ph.png",
	"./pk.png": "./src/assets/img/flags/pk.png",
	"./pl.png": "./src/assets/img/flags/pl.png",
	"./pm.png": "./src/assets/img/flags/pm.png",
	"./pn.png": "./src/assets/img/flags/pn.png",
	"./pr.png": "./src/assets/img/flags/pr.png",
	"./ps.png": "./src/assets/img/flags/ps.png",
	"./pt.png": "./src/assets/img/flags/pt.png",
	"./pw.png": "./src/assets/img/flags/pw.png",
	"./py.png": "./src/assets/img/flags/py.png",
	"./qa.png": "./src/assets/img/flags/qa.png",
	"./re.png": "./src/assets/img/flags/re.png",
	"./ro.png": "./src/assets/img/flags/ro.png",
	"./rs.png": "./src/assets/img/flags/rs.png",
	"./ru.png": "./src/assets/img/flags/ru.png",
	"./rw.png": "./src/assets/img/flags/rw.png",
	"./sa.png": "./src/assets/img/flags/sa.png",
	"./sb.png": "./src/assets/img/flags/sb.png",
	"./sc.png": "./src/assets/img/flags/sc.png",
	"./sd.png": "./src/assets/img/flags/sd.png",
	"./se.png": "./src/assets/img/flags/se.png",
	"./sg.png": "./src/assets/img/flags/sg.png",
	"./sh.png": "./src/assets/img/flags/sh.png",
	"./si.png": "./src/assets/img/flags/si.png",
	"./sj.png": "./src/assets/img/flags/sj.png",
	"./sk.png": "./src/assets/img/flags/sk.png",
	"./sl.png": "./src/assets/img/flags/sl.png",
	"./sm.png": "./src/assets/img/flags/sm.png",
	"./sn.png": "./src/assets/img/flags/sn.png",
	"./so.png": "./src/assets/img/flags/so.png",
	"./sr.png": "./src/assets/img/flags/sr.png",
	"./ss.png": "./src/assets/img/flags/ss.png",
	"./st.png": "./src/assets/img/flags/st.png",
	"./sv.png": "./src/assets/img/flags/sv.png",
	"./sx.png": "./src/assets/img/flags/sx.png",
	"./sy.png": "./src/assets/img/flags/sy.png",
	"./sz.png": "./src/assets/img/flags/sz.png",
	"./tc.png": "./src/assets/img/flags/tc.png",
	"./td.png": "./src/assets/img/flags/td.png",
	"./tf.png": "./src/assets/img/flags/tf.png",
	"./tg.png": "./src/assets/img/flags/tg.png",
	"./th.png": "./src/assets/img/flags/th.png",
	"./tj.png": "./src/assets/img/flags/tj.png",
	"./tk.png": "./src/assets/img/flags/tk.png",
	"./tl.png": "./src/assets/img/flags/tl.png",
	"./tm.png": "./src/assets/img/flags/tm.png",
	"./tn.png": "./src/assets/img/flags/tn.png",
	"./to.png": "./src/assets/img/flags/to.png",
	"./tr.png": "./src/assets/img/flags/tr.png",
	"./tt.png": "./src/assets/img/flags/tt.png",
	"./tv.png": "./src/assets/img/flags/tv.png",
	"./tw.png": "./src/assets/img/flags/tw.png",
	"./tz.png": "./src/assets/img/flags/tz.png",
	"./ua.png": "./src/assets/img/flags/ua.png",
	"./ug.png": "./src/assets/img/flags/ug.png",
	"./um.png": "./src/assets/img/flags/um.png",
	"./us.png": "./src/assets/img/flags/us.png",
	"./uy.png": "./src/assets/img/flags/uy.png",
	"./uz.png": "./src/assets/img/flags/uz.png",
	"./va.png": "./src/assets/img/flags/va.png",
	"./vc.png": "./src/assets/img/flags/vc.png",
	"./ve.png": "./src/assets/img/flags/ve.png",
	"./vg.png": "./src/assets/img/flags/vg.png",
	"./vi.png": "./src/assets/img/flags/vi.png",
	"./vn.png": "./src/assets/img/flags/vn.png",
	"./vu.png": "./src/assets/img/flags/vu.png",
	"./wf.png": "./src/assets/img/flags/wf.png",
	"./ws.png": "./src/assets/img/flags/ws.png",
	"./xk.png": "./src/assets/img/flags/xk.png",
	"./ye.png": "./src/assets/img/flags/ye.png",
	"./yt.png": "./src/assets/img/flags/yt.png",
	"./za.png": "./src/assets/img/flags/za.png",
	"./zm.png": "./src/assets/img/flags/zm.png",
	"./zw.png": "./src/assets/img/flags/zw.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/flags sync recursive ^\\.\\/.*\\.png$";